import React, { useState, useEffect } from 'react'
import { Form, Col, Row } from 'react-bootstrap'
import PropTypes from 'prop-types'
import { useLazyQuery } from '@apollo/client'

import styles from './style.module.scss'
import formStyles from '@assets/scss/components/form.module.scss'
import { FIXTURES_LIST } from '@graphql/series/fixtures.query'
import { fixtureLoader } from '@shared/libs/allLoader'
import CustomSelect from '@shared/components/customSelect'
import CustomFormGroup from '@shared/components/customForm/customFormGroup'
import FixturesItems from '@shared/components/series/fixturesItems'
import NoData from '@shared/components/noData'
import LazyLoad from '@shared/components/lazyLoad'
import useStatus from '@shared-submodule/sm-hooks/useStatus'

// const FixturesItems = dynamic(() => import('@shared/components/series/fixturesItems'), { loading: () => fixtureLoader() })

const Fixtures = ({ data, teamVenueData, id, seriesUrls }) => {
  const [payload, setPayload] = useState({ iTeamId: null, iVenueId: null, nOrder: 1, sSortBy: 'dStartDate' })
  const [value, setValue] = useState({ team: undefined, venue: undefined })
  const [flag, setFlag] = useState(0)
  const teams = teamVenueData?.fetchSeriesData?.aTeams
  const venues = teamVenueData?.fetchSeriesData?.aVenues

  const [updateFixture, { data: updateFixtureData, loading }] = useLazyQuery(FIXTURES_LIST, {
    variables: {
      input: {
        iSeriesId: id,
        ...payload
      }
    }
  })

  const updateData = updateFixtureData?.fetchFixuresData

  const handleFilterChange = (e, type) => {
    if (type === 'team') {
      setPayload({ ...payload, iTeamId: e === null ? null : e.sValue })
    } else {
      setPayload({ ...payload, iVenueId: e === null ? null : e.sValue })
    }
    setValue({ ...value, [type]: e })
    setFlag(1)
  }

  const fixtureData = flag === 0 ? data?.fetchFixuresData?.slice(0) : updateData?.slice(0)
  const fixtureDataLive = fixtureData?.filter((ele) => useStatus(ele)?.sStatusStr === 'live')
  const fixtureDataUpcoming = fixtureData?.filter((ele) => useStatus(ele)?.sStatusStr !== 'completed' && useStatus(ele)?.sStatusStr === 'scheduled')
  const fixtureDataScheduled = fixtureData?.filter((ele) => useStatus(ele)?.sStatusStr === 'completed' || useStatus(ele)?.sStatusStr === 'cancelled').reverse()
  const optionTeams = teams
    ?.map((team) => ({
      sValue: team._id,
      sLabel: team.sTitle
    }))

  const optionVenues = venues
    ?.map((venue) => ({
      sValue: venue._id,
      sLabel: venue.sName
    }))

  useEffect(() => {
    if (payload.iTeamId || payload.iVenueId) {
      updateFixture()
    }
  }, [payload])
  return (
    <>
      {data?.fetchFixuresData?.length !== 0 && <div className={`${styles.fixtures}`}>
        <Row>
          <Form className="d-flex align-items-center">
            <Row className={`${styles.filter} flex-grow-1 row-8`}>
              <Col xxl={3} md={4} sm={5} xs={6}>
                <CustomFormGroup className={`${formStyles.formGroup} mb-0`} controlId="teamSelect">
                  <CustomSelect
                    options={optionTeams}
                    value={value.team}
                    placeholder="Select Team"
                    labelKey="sLabel"
                    valueKey="sValue"
                    isClearable
                    isMedium={true}
                    onChange={(e) => {
                      handleFilterChange(e, 'team')
                    }}
                  />
                </CustomFormGroup>
              </Col>
              <Col xxl={3} md={4} sm={5} xs={6}>
                <CustomFormGroup className={`${formStyles.formGroup} mb-0`} controlId="venueSelect">
                  <CustomSelect
                    options={optionVenues}
                    value={value.venue}
                    placeholder="Select Venue"
                    labelKey="sLabel"
                    valueKey="sValue"
                    isClearable
                    isMedium={true}
                    onChange={(e) => {
                      handleFilterChange(e, 'venue')
                    }}
                  />
                </CustomFormGroup>
              </Col>
            </Row>
          </Form>
          {
            fixtureDataLive?.length > 0 && (
              <>
                <h3 className='small-head mt-3'>
                  Live
                </h3>
                {
                  fixtureDataLive?.map((fixture, index) => {
                    if (index < 2) {
                      return (
                        <Col xl={6} key={fixture._id} className='mb-4'>
                          <FixturesItems fixture={fixture} seriesUrls={seriesUrls} id={fixture._id} />
                        </Col>
                      )
                    } else {
                      return (
                        <LazyLoad key={fixture._id}>
                          <Col xl={6} key={fixture._id} className='mb-4'>
                            <FixturesItems fixture={fixture} seriesUrls={seriesUrls} id={fixture._id} />
                          </Col>
                        </LazyLoad>
                      )
                    }
                  })
                }
              </>
            )
          }
          {
            fixtureDataUpcoming?.length > 0 && (
              <>
                <h3 className='small-head mt-3'>
                  Upcoming
                </h3>
                {
                  fixtureDataUpcoming?.map((fixture, index) => {
                    if (index < 2 && fixtureDataLive?.length === 0) {
                      return (
                        <Col xl={6} key={fixture._id} className='mb-4'>
                          <FixturesItems fixture={fixture} seriesUrls={seriesUrls} id={fixture._id} />
                        </Col>
                      )
                    } else {
                      return (
                        <LazyLoad key={fixture._id}>
                          <Col xl={6} key={fixture._id} className='mb-4'>
                            <FixturesItems fixture={fixture} seriesUrls={seriesUrls} id={fixture._id} />
                          </Col>
                        </LazyLoad>
                      )
                    }
                  })
                }
              </>
            )
          }
          {
            fixtureDataScheduled?.length > 0 && (
              <>
                <h3 className='small-head mt-2'>
                  Finished
                </h3>
                {
                  fixtureDataScheduled?.map((fixture, index) => {
                    if (index < 2 && (fixtureDataUpcoming?.length === 0 && fixtureDataLive?.length === 0)) {
                      return (
                        <Col xl={6} key={fixture._id} className='mb-4'>
                          <FixturesItems fixture={fixture} seriesUrls={seriesUrls} id={fixture._id} />
                        </Col>
                      )
                    } else {
                      return (
                        <LazyLoad key={fixture._id}>
                          <Col xl={6} key={fixture._id} className='mb-4'>
                            <FixturesItems fixture={fixture} seriesUrls={seriesUrls} id={fixture._id} />
                          </Col>
                        </LazyLoad>
                      )
                    }
                  })
                }
              </>
            )
          }
        </Row>
        {loading && fixtureLoader()}
      </div>}
      {!loading && fixtureData?.length === 0 && <NoData title="No fixtures yet, but the thrill is on its way! Stay tuned for match updates. "/>}
    </>
  )
}

Fixtures.propTypes = {
  data: PropTypes.object,
  seriesUrls: PropTypes.object,
  teamVenueData: PropTypes.object,
  id: PropTypes.string
}

export default Fixtures
